/**
 * D-EZ-102 — the engine's sentence, in plain racing words: rulebook references
 * out (they come back with "Show rulebook citations"), and a chart's shouted
 * label — "TROUBLE RESULT:" — dropped from the front.
 */
import { stripCitations } from '../../lib/prefs.ts';

export function plainLine(text: string): string {
  const bare = stripCitations(text).replace(/^[A-Z][A-Z0-9 /&'-]{2,}:\s*/, '');
  return bare ? bare[0].toUpperCase() + bare.slice(1) : bare;
}
